import React, {ReactElement} from "react";
import * as SpinnerDots from "../Spinner/Spinner";
import * as Styles from "./Loader.styles";

export const Loader = (): ReactElement => {
    return (
        <Styles.Container>
            <SpinnerDots.FirstDot/>
            <SpinnerDots.SecondDot/>
            <SpinnerDots.ThirdDot/>
        </Styles.Container>
    );
};
